import styled from 'styled-components'

export const DetailList = styled.div`
  width: 48%;
  display: flex;
  flex-wrap: wrap;
`
